import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import { toggleSearch } from '@cotyorg/ccx-organism-header/modules';
import {
  fetchSearchResults,
  clearSearch,
  loadSearchHistory,
} from '../modules';

const SearchContainer = ({ childComponent: ChildComponent, ...props }) => (
  <ChildComponent {...props} />
);

SearchContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
  props: PropTypes.objectOf(PropTypes.any),
};

const mapDispatchToProps = dispatch => ({
  fetchSearchResults: term => dispatch(fetchSearchResults(term)),
  clearSearch: () => dispatch(clearSearch()),
  loadSearchHistory: () => dispatch(loadSearchHistory()),
  toggleSearchVisibility: () => dispatch(toggleSearch()),
});

const mapStateToProps = ({ search = {}, header = {}, content = {} }) => ({
  term: search.term,
  results: search.results,
  searchTermHistory: search.searchTermHistory,
  isShown: header.isSearchVisible,
  popularSearches: R.path(['search', 'popularSearches'])(content),
  placeholderText: R.path(['search', 'placeholderText'])(content),
  searchTitles: R.path(['search', 'titles'])(content),
  clearSearchTermHistoryButtonText: R.path(['search', 'clearSearchTermHistoryButtonText'])(content),
  contentLabel: R.path(['search', 'contentLabel'])(content),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchContainer);
